module.exports = "<p>\r\n  services works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/services.component.html
// module id = ./src/app/services/services.component.html
// module chunks = main